<div>
	<p class="p mb-2">Add Another Property Tax Adjustment?</p>
	<p class="p-sm text-gray-500">
		You already have a property tax adjustment. Are you sure you want to add
		another one?
	</p>
	<div class="mt-4">
		<ui-checkbox
			type="clear"
			[ngModel]="dontAskAgain"
			(ngModelChange)="setDontAskAgain($event)"
			label="Don't ask me again"
		></ui-checkbox>
	</div>
</div>
